module.exports = __webpack_public_path__ + "static/media/dynamex.ad5098cf.svg";